import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { addToViolationListFailed, addToViolationListSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* addToViolationList(action) {
  try {
    const url = `${BACKEND_URL}/api/v1/violation-list`;
    const dataResponse = yield makeRequest(url, action.payload, action, 'POST', true);
    if (dataResponse.status === OK) {
      yield put(addToViolationListSuccessful());
      yield call(resolveActionPromise(action));
    } else {
      const data = yield dataResponse.json();
      yield put(addToViolationListFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(addToViolationListFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
